// client/src/helpers/expertiseAreaTaxonomy.ts
//
// TRIL-116: source-of-truth list of expertise-area values accepted by the
// Plan C `setProfessionalContext` mutation. MUST be kept in sync with
// `server/src/enums/interests.enum.ts` — the server validates submissions
// against `Object.values(Interests)` from THAT file. Drift here causes the
// form to expose values the server will reject.
//
// The broader client `Interests` enum in `client/src/enums/interests.enum.ts`
// has additional display-only values used by Interests.tsx / CategoriesAutocomplete
// — those are intentionally NOT used by the Plan C form.

export const EXPERTISE_AREA_TAXONOMY: readonly string[] = [
  'AEROSPACE',
  'AI',
  'AI_ML',
  'ANDROID',
  'APPLE',
  'ART',
  'ASTRONOMY',
  'ASTROPHYSICS',
  'AUTISM',
  'AUTOMOTIVE',
  'BIOLOGY',
  'BLOCKCHAIN',
  'BUSINESS',
  'CAREER',
  'CINEMA',
  'CLIMATE_CHANGE',
  'CRYPTO',
  'CULTURE',
  'CYBERSECURITY',
  'DATA_SCIENCE',
  'DESIGN',
  'DIGITAL_ART',
  'DIY',
  'DRONES',
  'EDUCATION',
  'E_SPORTS',
  'ENGINEERING',
  'ENTREPRENEURSHIP',
  'ENVIRONMENT',
  'FARMING',
  'FILM',
  'FINANCE',
  'FITNESS',
  'FOOD',
  'GAMING',
  'GOVERNMENT',
  'HEALTH',
  'HEALTHCARE',
  'HISTORY',
  'INTERSTELAR_TRAVEL',
  'IOT',
  'LIFESTYLE',
  'LITERATURE',
  'MACHINE_LEARNING',
  'MARKETS',
  'MARKETING',
  'MATHEMATICS',
  'MEDICAL_TECH',
  'MENTAL_HEALTH',
  'MILITARY',
  'MOBILE_DEVELOPMENT',
  'MUSIC',
  'NUTRITION',
  'PHILOSOPHY',
  'PHOTOGRAPHY',
  'PHYSICS',
  'POLITICS',
  'PRODUCTIVITY',
  'PROGRAMMING',
  'PSYCHOLOGY',
  'RASPBERRY_PI',
  'RC',
  'RENEWABLE_ENERGY',
  'ROBOTICS',
  'SCIFI',
  'SCIENCE',
  'SECURITY',
  'SOCIAL_ISSUES',
  'SOCIAL_MEDIA',
  'SOLAR_ENERGY',
  'SPACE',
  'SPORTS',
  'STOCK_MARKET',
  'SUSTAINABILITY',
  'TECHNOLOGY',
  'TRAVEL',
  'UX_UI',
  'VIRTUAL_REALITY',
  'WAR',
  'WEB_DEVELOPMENT',
  'WINDOWS',
  'WOODWORKING',
] as const;

export type ExpertiseAreaTaxonomyValue =
  (typeof EXPERTISE_AREA_TAXONOMY)[number];
